import { apiClient } from '@/services/apiClient';
import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';

export interface Address {
  address: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
}

interface Response {
  addressResults: Address[];
}

export const useGetAddress = () => {
  return useMutation({
    mutationFn: async (search: string) => {
      return await apiClient.post<Response>(Routes.ADDRESS, {
        fullAddress: search,
      });
    },
  });
};
